export default class Locale_ScheduleRun {
	Timestamp: string = "Timestamp";
	Duration: string = "Duration in seconds";
}